// IMPORTANT Autogenerated file
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GoodToBeTransferredOrUnloadedDto } from '@ellf/common-dto';
import { ApiClientConfig } from '../api-client-config';
import { BaseCRUDApiClient } from './baseCRUD.api-client';

@Injectable()
export class GoodToBeTransferredOrUnloadedApiClient extends BaseCRUDApiClient<GoodToBeTransferredOrUnloadedDto> {
  baseUrl = this.config.apiEndpoint + '/good-to-be-transferred-or-unloaded';

  constructor(http: HttpClient, config: ApiClientConfig) {
    super(http, config);
  }
}
